export const GLOBAL_CONSTANTS = {
  POPOVER_ENTER_DELAY: 200,
  POPOVER_LEAVE_DELAY: 500,
};

export enum Focusable {
  NodeTree = "node-tree",
  FilterField = "filter-field",
}
